import * as React from "react";
const SvgMntn = (props, ref) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 130 130"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    {...{ ...props, ref }}
  >
    <defs>
      <linearGradient
        x1={77.697}
        y1={56.374}
        x2={104.787}
        y2={41.314}
        id="MNTN_svg__c"
        gradientTransform="scale(.87582 1.14178)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#045562" offset="0%" />
        <stop stopColor="#05606F" offset="3%" />
        <stop stopColor="#06778A" offset="10%" />
        <stop stopColor="#088BA0" offset="18%" />
        <stop stopColor="#0999B1" offset="27%" />
        <stop stopColor="#09A3BC" offset="39%" />
        <stop stopColor="#0AA9C3" offset="55%" />
        <stop stopColor="#0AABC5" offset="100%" />
      </linearGradient>
      <linearGradient
        x1={83.57}
        y1={52.119}
        x2={101.219}
        y2={39.062}
        id="MNTN_svg__d"
        gradientTransform="scale(.75928 1.31703)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#045562" offset="0%" />
        <stop stopColor="#05606F" offset="3%" />
        <stop stopColor="#06778A" offset="10%" />
        <stop stopColor="#088BA0" offset="18%" />
        <stop stopColor="#0999B1" offset="27%" />
        <stop stopColor="#09A3BC" offset="39%" />
        <stop stopColor="#0AA9C3" offset="55%" />
        <stop stopColor="#0AABC5" offset="100%" />
      </linearGradient>
      <filter
        x={-0.07}
        y={-0.07}
        width={1.157}
        height={1.157}
        filterUnits="objectBoundingBox"
        id="MNTN_svg__a"
      >
        <feOffset dx={2} dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={3.5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <rect
        id="MNTN_svg__b"
        x={0}
        y={0}
        width={119.638}
        height={119.642}
        rx={16.314}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero" transform="translate(5.058 4.998)">
        <use
          fill="currentColor"
          filter="url(#MNTN_svg__a)"
          xlinkHref="#MNTN_svg__b"
        />
        <use fill="#f6f6f6" xlinkHref="#MNTN_svg__b" />
      </g>
      <path d="M64.023 64.161a.152.152 0 0 0 .033.06l10.066 17.457L64.056 64.22Z" />
      <path
        d="M64.056 64.221a.152.152 0 0 1-.033-.06l-.048-.092c-.506-.892-1.088-1.855-1.632-2.866l-16.13-28.007a2.12 2.12 0 0 0-.413-.544 3.431 3.431 0 0 0-2.637-1.006H29.986a4.002 4.002 0 0 0-4.002 4.008v58.82a3.562 3.562 0 0 0 2.3 3.399 3.464 3.464 0 0 0 3.573-.816l11.817-11.823a3.491 3.491 0 0 1 4.019-.647l14.683 7.353a3.486 3.486 0 0 0 4.274-.936l7.456-9.326z"
        fill="#1ac9aa"
        fillRule="nonzero"
      />
      <path
        d="M81.539 26.582a3.933 3.933 0 0 0-3.426 1.99c-4.78 8.36-12.464 22.417-17.402 30.488a1.044 1.044 0 0 1-1.74.108h-.006L69.048 76.68l7.798-9.865a3.453 3.453 0 0 1 5.134-.282l10.794 10.795c.494.512 1.13.864 1.827 1.011a3.437 3.437 0 0 0 4.117-3.372v-44.42a3.965 3.965 0 0 0-3.97-3.964Z"
        fill="url(#MNTN_svg__c)"
        fillRule="nonzero"
        style={{
          fill: "url(#MNTN_svg__c)",
        }}
        transform="translate(5.058 4.998)"
      />
      <path
        d="M64.023 64.161a.152.152 0 0 0 .033.06l10.066 17.457L64.056 64.22Z"
        fill="#1ac9aa"
        fillRule="nonzero"
      />
      <path
        d="M58.965 59.163a.152.152 0 0 0 .033.06l10.066 17.456-10.066-17.456Z"
        fill="url(#MNTN_svg__d)"
        fillRule="nonzero"
        style={{
          fill: "url(#MNTN_svg__d)",
        }}
        transform="translate(5.058 4.998)"
      />
    </g>
  </svg>
);
export default React.forwardRef(SvgMntn);
